import { IconButton, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MenuPortal } from "shared/components/menu/MenuPortal";
import { MoreVerticalIcon } from "shared/icons/MoreVerticalIcon";

export const DataTableColumnMenuBase: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <Menu
      offset={[0, 0]}
      placement="bottom-end"
      isLazy={true}
      lazyBehavior="unmount"
    >
      <MenuButton
        as={IconButton}
        variant="ghost"
        size="xxs-icon"
        color="gray.500"
        flexShrink={0}
        mr="-8px"
        aria-label={t("common:table.columnMenu")}
        icon={<MoreVerticalIcon />}
        sx={{
          display: "none",
          [".ag-header-cell:hover &, " +
          // keep visible when menu is open
          ".mb-header-cell-comp:has([aria-expanded=true]) &"]: {
            display: "inline-flex",
          },
        }}
        onClick={(e) => {
          // prevent click from propagating to the header cell
          e.stopPropagation();
        }}
      />
      <MenuPortal>
        <MenuList
          shadow="md"
          border="1px solid gray.25"
          onClick={(e) => {
            // prevent click from propagating to the header cell
            e.stopPropagation();
          }}
        >
          {children}
        </MenuList>
      </MenuPortal>
    </Menu>
  );
};
